import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CalendlyWidget from '@/components/feature/CalendlyWidget';
import { ScrollReveal } from '@/components/feature/PageLayout';

export default function AgendaPage() {
  return (
    <>
      <Navbar />
      <main>
        {/* Título editorial */}
        <ScrollReveal>
          <section className="relative bg-background-50 pt-32 pb-8 md:pt-40 md:pb-12">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
              <div className="reveal-on-scroll">
                <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-[0.02em] text-foreground-950 leading-[0.95] mb-6">
                  AGENDA
                </h1>
                <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-[640px]">
                  Elige el día y hora que mejor se adapte a tu ritmo. Una conversación sin costo para conocernos, entender tu momento profesional y explorar juntos cómo puedo acompañarte con el Método CALMA©.
                </p>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="border-t border-foreground-200/60"></div>
        </div>

        {/* Calendly Widget */}
        <section className="relative bg-background-50 py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
              {/* Info izquierda */}
              <div className="lg:w-4/12">
                <div className="lg:sticky lg:top-28">
                  <p className="text-foreground-400 text-xs tracking-[0.2em] mb-4">SESIÓN INICIAL</p>
                  <h2 className="font-heading text-2xl md:text-3xl font-light tracking-[0.02em] text-foreground-900 leading-[1.25] mb-5">
                    Sin costo.<br />Sin compromiso.<br />Con intención.
                  </h2>
                  <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                    <div className="flex items-start gap-3">
                      <div className="w-1.5 h-1.5 rounded-full bg-accent-500 mt-2 flex-shrink-0"></div>
                      <p>Duración aproximada: <strong className="text-foreground-800 font-medium">30 minutos</strong></p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-1.5 h-1.5 rounded-full bg-accent-500 mt-2 flex-shrink-0"></div>
                      <p>Modalidad: <strong className="text-foreground-800 font-medium">videollamada</strong></p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-1.5 h-1.5 rounded-full bg-accent-500 mt-2 flex-shrink-0"></div>
                      <p>Recibirás un enlace por correo tras agendar</p>
                    </div>
                  </div>

                  <div className="mt-8 p-5 rounded-xl bg-background-100 border border-background-200/70">
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      <span className="text-foreground-700 font-medium">¿Ya eres cliente?</span> Si necesitas agendar tu siguiente sesión de acompañamiento, escríbeme directamente y coordinamos.
                    </p>
                  </div>
                </div>
              </div>

              {/* Calendly embed */}
              <div className="lg:w-8/12">
                <CalendlyWidget url="https://calendly.com/celc-erika/30min" />
              </div>
            </div>
          </div>
        </section>

        {/* Cita final */}
        <ScrollReveal>
          <section className="relative bg-foreground-950 py-16 md:py-24">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 text-center">
              <div className="reveal-on-scroll max-w-[640px] mx-auto">
                <p className="font-heading text-xl md:text-2xl italic font-light text-background-50/80 leading-relaxed mb-6">
                  &ldquo;Las mejores decisiones profesionales nacen cuando hay espacio para la reflexión, no cuando hay prisa por resolver.&rdquo;
                </p>
                <p className="text-sm text-background-50/40 tracking-[0.05em]">
                  — Erika López Castañeda
                </p>
              </div>
            </div>
          </section>
        </ScrollReveal>
      </main>
      <Footer />
    </>
  );
}